import axios from "axios";
import APIS from "./api";

class Service {
	getAPIS() {
		return APIS;
	}
	post() {
		return axios.post(`${APIS[arguments[0]]}/${arguments[1]}`, arguments[2], arguments[3]);
	}
	put() {
		return axios.put(`${APIS[arguments[0]]}/${arguments[1]}`, arguments[2], arguments[3]);
	}
	get() {
		return axios.get(`${APIS[arguments[0]]}/${arguments[1]}`, arguments[2]);
	}
	delete() {
		return axios.delete(`${APIS[arguments[0]]}/${arguments[1]}`, arguments[2]);
	}
	url() {
		return `${APIS[arguments[0]]}/${arguments[1]}`;
	}
	create(method, url, ...rest) {
		return axios[method](url, ...rest);
	}
}

export default new Service();
